export class PrecioVenta{
    
    public constructor(
        public precio:string = "",
        public producto_id:String = "",
        public empresa_id: String = "",
        public incluye_iva: boolean = false,
        public usuario_id:String = null
    ){}

}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/precio-venta.ts